import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import axios from 'axios';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {setGlobalTypeState, setSidebarState, addRowPlaceholder, removeElement, addElement, setSelectedTab, addRow, moveRow, setSelectedRow} from '../../actions/Builder.js';

import Spin2Win from '../../components/Spin2Win.js';

import Nav from './Nav';
import General from '../../modules/General';
import AskUpgrade from "../../components/AskUpgrade";

class Picker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'selectedStep1': false,
            'selectedStep2': false,
            'selectedStep3': false,
            'isLoading': true,
            'askUpgrade': false,
            'categories': []
        }

        contextTypes: {
            router: React.PropTypes.object.isRequired
        }

        this.onSelect = this.onSelect.bind(this);
        this.currentStep = this.currentStep.bind(this);
        this.validate = this.validate.bind(this);
        this.restart = this.restart.bind(this);



    }

    restart() {
        this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/picker/1'));
    }

    load() {
        axios.get('/picker/' + this.props.router.params.type)
            .then((response) => {
                this.setState({'categories': response.data, 'isLoading': false});
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    currentStep() {
        return parseInt(this.props.router.routes[this.props.router.routes.length - 1].path);
    }

    nextStep() {
        let next = (this.currentStep() + 1);
        if (typeof this.state['selectedStep' + next] === 'undefined') {
            next = false;
        }
        return next;
    }

    validate() {
        const previousSteps = this.currentStep() - 1;
        for (let i = 1; i <= previousSteps; i++) {
            if (this.state['selectedStep' + i] == false) {
                return i;
            }
        }

        return true;
    }

    onSelect(val) {
        if (val == 3 && this.currentStep() == 1) {
            if (this.props.general.settings.PACKAGE_OC != '1' && this.props.general.settings.PACKAGE_EMAIL != '1') {
                this.setState({askUpgrade: true});
                return;
            }
        }

        if (this.props.router.params.type == 'email' && this.currentStep() == 2) {
            if (this.props.general.settings.PACKAGE_EMAIL != '1') {
                this.setState({askUpgrade: true});
                return;
            }
        }

        if (this.props.router.params.type == 'popup' && this.currentStep() == 2) {
            if (this.props.general.settings.PACKAGE_POPUP != '1') {
                this.setState({askUpgrade: true});
                return;
            }
        }

        let step_state = {
            ...this.state,
            ['selectedStep' + this.currentStep()]: val
        };

        //skip step two for email segemnts
        if (this.props.router.params.type == 'email' && this.currentStep() == 1 && val == 9) {
            if (this.props.general.settings.PACKAGE_SEGMENTS != '1') {
                this.setState({askUpgrade: true});
                return;
            } else {
                step_state['selectedStep2'] = '-';
                this.setState(step_state);
                this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/picker/3'));
                return;

            }

        }

        //skip step two for email triggers
        if (this.props.router.params.type == 'email' && this.currentStep() == 1 && val == 10) {
            if (this.props.general.settings.PACKAGE_TRIGGERS != '1') {
                this.setState({askUpgrade: true});
                return;
            } else {
                step_state['selectedStep2'] = '-';
                this.setState(step_state);
                this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/picker/3'));
                return;

            }

        }


        this.setState(step_state);

        if (this.nextStep() === false) {
            this.setState({isLoading: true});
            axios.post('/picker/' + this.props.router.params.type, {
                step1: this.state.selectedStep1,
                step2: this.state.selectedStep2,
                step3: val,
            }).then(res => {
                this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/' + res.data.id));
            });

        } else {
            this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/picker/' + this.nextStep()));
        }
    }

    componentWillMount() {
        this.addBodyClass(true);
        if (this.validate() !== true) {
            this.props.router.push(General.Link('/builder/' + this.props.router.params.type + '/picker/' + this.validate()))
        }
    }

    componentDidUpdate() {
        this.addBodyClass(true);
        if (this.validate() !== true) {
            this.restart();
        }
    }

    componentWillUnmount() {
        this.addBodyClass(false);
    }

    addBodyClass(add) {
        if (add) {
            document.body.classList.add('picker');

        } else {
            document.body.classList.remove('picker');

        }
    }

    getRedirectLink = () => {
        if (!this.isUsingFlows()) {
            return General.Link(this.emailOrPopup());
        }

        return General.Link2("/popups");


    }

    isUsingFlows() {
        return this.props.general.settings.FLOW == '1' ? true : false;
    }

    emailOrPopup() {
        return this.props.router.params.type == 'email' ? '/emails' : '/popups';
    }

    componentDidMount() {
        this.load();
    }

    render() {

        const childrenWithProps = React.Children.map(this.props.children, (child) => React.cloneElement(child, {
            onSelect: this.onSelect,
            categories: this.state.categories,
            selectedStep1: this.state.selectedStep1,
            selectedStep2: this.state.selectedStep2,
            selectedStep3: this.state.selectedStep3,
            restart: this.restart,
        })
        );
        return (
            <div className="height-100">
                <Nav backLink={this.getRedirectLink()} backText={`Back to ${(this.props.router.params.type == 'email' ? 'emails' : 'popups')}`}>

                </Nav>

                {this.state.isLoading ? <div className="loading"><Spin2Win /></div> : null}


                <div className="row margin-top-20">
                    <div className="">
                        <div className="col-sm-8 offset-sm-2">{childrenWithProps}</div>
                    </div>
                </div>


                <AskUpgrade onAccept={(e) => {this.setState({askUpgrade: false}); this.props.router.push(General.Link('/settings/billing/plan'))}} onClose={() => {this.setState({askUpgrade: false})}} param={this.state.askUpgrade} title="Upgrade required" body="To use this feature you must upgrade to a larger package." />
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        picker: state.picker,
        general: state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setGlobalTypeState, setSidebarState, addRow, addRowPlaceholder, removeElement, setSelectedTab, setSelectedRow, moveRow}, dispatch)
}

Picker = connect(mapStateToProps, mapDispatchToProps)(Picker);
export default Picker;



// WEBPACK FOOTER //
// ./containers/builder/Picker.js